import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  breakpoints, fontWeights, borderRadiuses, palette,
}: Theme) => ({
  root: {
    paddingTop: '2rem',
    paddingBottom: '2rem',
    [breakpoints.up('md')]: {
      paddingTop: '4rem',
      paddingBottom: '4rem',
    },
  },
  title: {
    margin: '0 0 2rem',
    fontSize: '1.75rem',
    fontWeight: fontWeights.medium,
    lineHeight: 1.35,
  },
  subtitle: {
    margin: '2rem 0 0.75rem',
    fontSize: '1rem',
    fontWeight: fontWeights.medium,
    lineHeight: 1.5,
  },
  text: {
    margin: '0 0 0.5rem',
    '&:last-of-type': {
      marginBottom: 0,
    },
  },
  list: {
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem',
    padding: 0,
    margin: '0 0 2rem',
  },
  listItem: {
    position: 'relative',
    minHeight: '1.5rem',
    paddingLeft: '2rem',
  },
  sublist: {
    listStyleType: 'disc',
    paddingLeft: '1.25rem',
    margin: '0.5rem 0 0',
    '& li': {
      marginBottom: '0.5rem',
    },
    '& li:last-child': {
      marginBottom: 0,
    },
  },
  icon: {
    position: 'absolute',
    top: 0,
    left: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '1.5rem',
    height: '1.5rem',
    borderRadius: borderRadiuses.xxl,
    background: palette.custom.main,
    color: palette.common.white,
    fontSize: '0.875rem',
    fontWeight: fontWeights.medium,
  },
  link: {
    display: 'block',
    width: 'fit-content',
    color: palette.primary.dark,
    textDecoration: 'underline',
  },
}));
